import { useQuery } from 'react-query'
import type { Department } from '~/types/department.types'
import httpClient from '~/utils/httpClient'

export const useDepartmentsList = () => {
  const q = useQuery({
    queryKey: ['departments'],
    queryFn: async () => {
      const response = await httpClient.get<{
        data: Department[]
      }>('/api/departments')
      return response?.data.data
    },
  })
  return q
}
